"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(_this) {
  return {
    isFirst: function isFirst() {
      return _this._parent.isChildFirst;
    },
    isLast: function isLast() {
      return _this._parent.isChildLast;
    }
  };
};

exports.default = _default;